export const GET_JOBSEEKER = "GET_JOBSEEKER";
// export const GET_CLIENT_DETAILS = "GET_CLIENT_DETAILS";